export const iconButtonClass =
    "size-11 flex items-center justify-center rounded-tile bg-true-black/4 transition-[background-color,transform] active:bg-true-black/8 active:scale-[0.96] active:duration-100 motion-reduce:active:scale-100 cursor-pointer";
